import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, View, ViewHeader } from '../components/Index';
import { AppPermissions } from '../services/AppPermissions';
export const NotAuthorizedView: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <View id="NotAuthorizedView" pageTitle="Page Not Authorized!" container={true} authKey={AppPermissions.PublicAccess}>
        <ViewHeader title="Page Not Authorized!">
          <Button title="Back" className="btn-secondary" icon="arrow-left" onClick={() => navigate(-1)} />
        </ViewHeader>
        <div className="space-y-6 mt-6">
          <div className="bg-white rounded-xl mb-4 text-center py-16 px-6 shadow-card border border-gray-25 space-y-8">
            <div>
              <h2 className="font-medium text-lg md:text-2xl text-gray-800">Sorry!</h2>
              <p className="text-gray-500 max-w-2xl mx-auto text-sm md:text-base">
                You&apos;re looking for a page which you have not authorized to view. Please contact system administrator for more information.
              </p>
            </div>
          </div>
        </div>
      </View>
    </>
  );
};
